export default __webpack_public_path__ + "static/media/icon-benchToBench.ef840d08.svg";